import { render, staticRenderFns } from "./FieldImport.vue?vue&type=template&id=264e6d8c"
import script from "./FieldImport.vue?vue&type=script&lang=js"
export * from "./FieldImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports